import { BaseElement, defineElement } from '@webtides/element-js';

class AnimateScrollEntrance extends BaseElement {
    properties() {
        return {
            rootMargin: '0px 0px -200px 0px',
            threshold: 0,
            entranceAnimation: 'animate__fadeInUp',
            leaveAnimation: 'animate__fadeOut',
            delay: 100,
            hasEntered: false,
            animateSelector: '[animate]',
        };
    }

    connected() {
        this.elementToAnimate = this.querySelector(this.animateSelector) || this.firstElementChild;
        this.elementToAnimate.style.setProperty('opacity', '0');

        // reset animation state, for example to avoid bugs with the z-index etc.
        this.elementToAnimate.style.animationFillMode = 'none';

        this._intersetionObserver = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !this.hasEntered) this.enter();
                });
            },
            {
                rootMargin: this.rootMargin,
                threshold: this.threshold,
            },
        );

        this._intersetionObserver.observe(this);
    }

    enter() {
        this.hasEntered = true;

        this.elementToAnimate.classList.add('animate__animated');
        this.elementToAnimate.classList.add(this.entranceAnimation);
        this.elementToAnimate.style.removeProperty('opacity');

        this._intersetionObserver.unobserve(this);
    }
}

export function define() {
    defineElement('animate-scroll-antrance', AnimateScrollEntrance);
}
